export const APPLICATION_FRAME = "ApplicationFrame";

export const MASTER_DETAIL = "MasterDetail";

export const PROCESS_MASTER_DETAIL = "ProcessMasterDetail";

export const STAMMDATEN_MASTER_DETAIL = "StammdatenMasterDetail";

export const DASHBOARD = "Dashboard";
